import React from "react";
import { Trash2 } from "lucide-react";
import api from "../../../../services/api";

const CardCartao = ({ id, ultimosNumeros, onDeleteSuccess }) => {
  const usuarioStorage = JSON.parse(localStorage.getItem("usuario")) || {};
  const token = localStorage.getItem("token");

  const handleDelete = async () => {
    const confirmar = window.confirm("Tem certeza que deseja excluir este cartão?");
    if (!confirmar) return;

    try {
      const { data } = await api.delete(
        `cliente/cartoes/${usuarioStorage._id}/${id}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      if (!data.error) {
        alert("Cartão excluído com sucesso!");
        onDeleteSuccess?.(); // 🔄 chama o recarregamento da lista
      } else {
        alert(data.message || "Erro ao excluir cartão.");
      }
    } catch (err) {
      console.error("Erro ao excluir cartão:", err.message);
      alert("Erro ao excluir cartão.");
    }
  };

  return (
    <div className="flex items-center justify-between bg-gray-100 border border-gray-300 rounded-lg px-4 py-3 shadow-sm">
      {/* Logo + número do cartão */}
      <div className="flex items-center space-x-3">
        <img
          src="https://upload.wikimedia.org/wikipedia/commons/5/5e/Visa_Inc._logo.svg"
          alt="Visa"
          className="h-5 w-auto"
        />
        <span className="font-mono text-sm text-gray-800 tracking-widest">
          **** **** **** {ultimosNumeros}
        </span>
      </div>

      {/* Ícone de excluir */}
      <Trash2
        size={18}
        className="text-red-500 cursor-pointer"
        onClick={handleDelete}
      />
    </div>
  );
};

export default CardCartao;
